import styled from 'styled-components';

export const PageHeader = styled.h1``;


// WEBPACK FOOTER //
// ./src/common/page-header.tsx